/**
 * Sehrli raqamlar bu yerda. CLAUDE.md §5 — kodda magic number bo'lmasin.
 */

// TZ-docs/08-design-system.md §8.5.10 — qarz zonalari chegaralari
export const DEBT_ZONE_WARN_THRESHOLD = 200_000;
export const DEBT_ZONE_DANGER_THRESHOLD = 500_000;

// TZ-docs/03-rollar-rbac.md §3.1
export const ADMIN_LIMIT = 2;

// Backend `validate_password_strength` (schemas/user.py) bilan bir xil
export const MIN_PASSWORD_LENGTH = 6;

export const ROLE = {
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  COURIER: 'COURIER',
  AGENT: 'AGENT',
  CLIENT: 'CLIENT',
} as const;

export type Role = (typeof ROLE)[keyof typeof ROLE];

export const ROLE_LABEL_UZ: Record<Role, string> = {
  ADMIN: 'Administrator',
  MANAGER: 'Zam',
  COURIER: 'Dostavshik',
  AGENT: 'Agent',
  CLIENT: 'Klient',
};

// Rol bo'yicha login'dan keyingi asosiy sahifa
export const ROLE_HOME_PATH: Record<Role, string> = {
  ADMIN: '/admin/dashboard',
  MANAGER: '/manager',
  COURIER: '/courier',
  AGENT: '/agent',
  CLIENT: '/client',
};

/** Impersonatsiyadan chiqqach (qo'lda yoki token muddati tugab) admin qaytadigan sahifa */
export const IMPERSONATION_EXIT_PATH = '/admin/users';

export const CURRENCY_LABEL = "so'm";

export const TOKEN_STORAGE_KEY = 'ibrohim.auth';

// Tema (light/dark/auto) — src/lib/theme/index.ts
export const THEME_STORAGE_KEY = 'ibrohim.theme';

// Interfeys tili (uz/ru) — src/lib/i18n/index.ts
export const LANG_STORAGE_KEY = 'ibrohim.lang';

// TZ-docs/14-pwa-offline.md §14.4 — offline navbatga tushadigan endpointlar
export const OFFLINE_QUEUE_ENDPOINTS = [
  '/deliveries',
  '/returns',
  '/payments',
  '/expenses',
  '/shifts/{id}/batches',
  '/stores',
  '/ratings',
] as const;

// Exponential backoff — §14.4
export const RETRY_DELAYS_MS = [5_000, 30_000, 120_000, 600_000];
export const RETRY_MAX_ATTEMPTS = 10;
export const QUEUE_EXPIRY_MS = 24 * 60 * 60 * 1000;

// Teskari geokoder (koordinata → taxminiy manzil) — src/api/geocoder.ts
export const GEOCODER_REVERSE_URL = 'https://geo.mangomarket.uz/reverse';
/** Servis sekin bo'lsa kutib o'tirmaymiz — manzil qo'lda kiritilaveradi */
export const GEOCODER_TIMEOUT_MS = 5_000;
/** Marker surilganda yoki Lat/Lng yozilganda har harakatga so'rov ketmasin */
export const GEOCODER_DEBOUNCE_MS = 600;
/** Backend `stores.address` — VARCHAR(255) */
export const STORE_ADDRESS_MAX_LENGTH = 255;

// --- F1 · Klient ekranlari (features/client/**) ---

/** TZ-docs/09-ekran-klient.md K-03 — bugun 18:00 gacha "Bugun" tanlash mumkin */
export const SAME_DAY_ORDER_CUTOFF_HOUR = 18;

/** TZ-docs/09 K-07 — har kuni 20:00 da avtomatik rejali buyurtma yaratiladi */
export const PLANNED_ORDER_CUTOFF_HOUR = 20;

/** Backend `settings.delivery_slots` tayyor bo'lmaguncha ishlatiladigan zaxira oraliqlar */
export const DEFAULT_DELIVERY_SLOTS: { from: string; to: string }[] = [
  { from: '06:00', to: '08:00' },
  { from: '07:00', to: '09:00' },
  { from: '08:00', to: '10:00' },
];

/** Backend `quick_qty_options` bermasa ishlatiladigan zaxira tez tanlash qiymatlari (K-02) */
export const DEFAULT_QUICK_QTY_OPTIONS = [10, 20, 40, 50];

/** ISO hafta kuni (1=Du…7=Ya) → 2 harfli o'zbekcha qisqartma (K-07) */
export const WEEKDAY_SHORT_LABEL_UZ: Record<number, string> = {
  1: 'Du',
  2: 'Se',
  3: 'Ch',
  4: 'Pa',
  5: 'Ju',
  6: 'Sh',
  7: 'Ya',
};
export const WEEKDAYS_ALL = [1, 2, 3, 4, 5, 6, 7];
export const WEEKDAYS_WORKDAYS = [1, 2, 3, 4, 5, 6];

/** K-10 — yulduz soniga qarab matn */
export const RATING_STAR_LABEL_UZ: Record<number, string> = {
  1: 'Yomon',
  2: "O'rtacha",
  3: 'Yaxshi',
  4: 'Juda yaxshi',
  5: 'Ajoyib!',
};

/** K-10 — yulduz soniga qarab tez tanlash teglari */
export const RATING_QUICK_TAGS: Record<number, string[]> = {
  1: ['Kech keldi', 'Non kam edi', "Muomalasi yomon"],
  2: ['Kech keldi', 'Non kam edi'],
  3: ['Vaqtida keldi', 'Non yaxshi'],
  4: ['Vaqtida keldi', 'Xushmuomala', 'Non yaxshi'],
  5: ['Vaqtida keldi', 'Xushmuomala', 'Non yaxshi', 'Toza yetkazdi'],
};
